export const logins = {
  'andwin': '9403',
  'azer': '9000',
  'bsi': '1294',
  'blueridge': '1337',
  'cleanroom': '9932',
  'dai': '8930',
  'daigger': '0223',
  'define': '9292',
  'dsi': '5032',
  'ecom': '6454',
  'farnell': '8494',
  'fisher': '9932',
  'genesee': '8320',
  'gmi': '0196',
  'h2i': '7773',
  'herr': '9013',
  'kewaunee': '0032',
  'kloeppel': '0192',
  'labtech': '1023',
  'labdepot': '7849',
  'labrepco': '7493',
  'lbi': '0459',
  'loc': '8302',
  'lps': '0203',
  'mglabsolutions': '0293',
  'midland': '1205',
  'nelson': '0029',
  'neta': '8493',
  'nova': '0739',
  'nowak': '7712',
  'nurnberg': '0182',
  'nycom': '9921',
  'omnilab': '3959',
  'officeplanners': '8064',
  'onepointe': '0381',
  'proline': '4851',
  'qaline': '3820',
  'scott': '9302',
  'spectrum': '9321',
  'spectrumrx': '9321',
  'srs': '0281',
  'stellar': '7123',
  'superior': '8493',
  'taylor': '9320',
  'thermal': '2017',
  'thomas': '4022',
  'technimark': '4815',
  'weber': '7393',
  'test': '0099',
  'phillocraft': '1020',
  'biologix': '8686',
  'labpro': '4785',
  'emerald': '4897',
  'ares': '2312',
  'labbuild': '1411',
  'scilogex': '2727',
}